import React, {useState} from 'react';
import {Button, Dropdown, Icon} from "react-materialize";
import styled from "styled-components";

const StyledFilterItem = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`

const StyledClearButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  background-color: #3582C5;
  color: white;
  position: absolute;
  right: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
  border-radius: 3px;
  box-shadow: 
    0 2px 2px 0 rgb(0 0 0 / 14%), 
    0 3px 1px -2px rgb(0 0 0 / 12%), 
    0 1px 5px 0 rgb(0 0 0 / 20%);
    
    span {
      font-size: 1.5rem;
      padding-right: 0.5rem;
    }
    
    i {
      font-size: 1.2rem;
    }
    
    :hover {
      background-color: #dceaf6;
      color: #3582C5;
    }
`

const StyledListItem = styled.div`
  li {
    background-color: white;
    color: #333D48;
    text-align: center;
    font-size: 1.4rem;
    padding: 1rem;
    padding-top: 1.5rem;
    :hover {
      color: #0f82c5;
    }
  }
`
const StyledAddButton = styled(Button)`
  i {
    padding-right: 2px;
  }
`

const Filter = ({label = 'label', listItems, handleFilter}) => {
  const [active, setActive] = useState(false);
  const [activeLabel, setActiveLabel] = useState();

  const handleClick = (filter) => {
    // setActive(!active);
    setActiveLabel(filter);
    handleFilter(filter);
  }

  return (
    <StyledFilterItem>
      <Dropdown
        id={`${label}-dropdown`}
        options={{
          alignment: 'left',
          autoTrigger: true,
          closeOnClick: true,
          constrainWidth: true,
          container: null,
          coverTrigger: true,
          hover: false,
          inDuration: 150,
          onCloseEnd: null,
          onCloseStart: null,
          onOpenEnd: null,
          onOpenStart: null,
          outDuration: 250
        }}
        trigger={<StyledAddButton className={'filter-button'} node="button"><Icon>add</Icon>{activeLabel ? activeLabel : label}</StyledAddButton>}
      >
        {
          listItems.map((filter) => {
            return <StyledListItem onClick={() => handleClick(filter)}><li>{filter}</li></StyledListItem>
          })
        }
      </Dropdown>
      {
        activeLabel && <StyledClearButton onClick={() => handleClick('')}><span>{activeLabel}</span> <Icon>clear</Icon></StyledClearButton>
      }
    </StyledFilterItem>
  )
}

export default Filter;